import * as lexActionType from '../actionsType/lexDetail.actionType';

// sde19: this reducer is used for content details page
export const initialState = {
    status: lexActionType.FETCHING_LEX,
    response: null,
    exception: null,
    isEnrolled: '',
    isBlock: false,
    lexErrorMessage: '',
    lexLastLaunched: {}
};

export function lexDetailReducer(state = initialState, action) {
    switch (action.type) {
        case lexActionType.FETCHING_LEX:
            return {...state, response: null, status: lexActionType.FETCHING_LEX};
        case lexActionType.FETCHING_LEX_SUCCESS:
            return {...state, response: action.payload, status: lexActionType.FETCHING_LEX_SUCCESS};
        case lexActionType.FETCHING_LEX_ERROR:
            return {...state, status: lexActionType.FETCHING_LEX_ERROR, lexErrorMessage: action.payload};
        case lexActionType.SET_IS_ENROLLED:
            return {...state, isEnrolled: action.payload};
        case lexActionType.SET_LEX_LASTLAUNCHED:
            return {...state, lexLastLaunched: action.payload};
        default:
            return state;
    }
}
